const TAG_URL = process.env.API_URL + '/tag/';

const getTree = (context) => {
  return context.$http.get(TAG_URL + 'tree');
};

const getReadTree = (context) => {
  return context.$http.get(TAG_URL + 'read-tree');
};

const updateTree = (context, tree) => {
  return context.$http.put(TAG_URL, tree);
};

const deleteNodes = (context, nodes) => {
  return context.$http.delete(TAG_URL, { body: nodes });
};

const addTags = (context, variableIds, tagIds) => {
  return context.$http.put(TAG_URL + 'add/', { variableIds: variableIds, tagIds: tagIds });
};

const removeTags = (context, variableIds, tagIds) => {
  return context.$http.put(TAG_URL + 'remove/', { variableIds: variableIds, tagIds: tagIds });
};

export default {
  getTree,
  getReadTree,
  updateTree,
  deleteNodes,
  addTags,
  removeTags
};



// WEBPACK FOOTER //
// ./src/api/tag/tagHttp.js